module.exports = __webpack_public_path__ + "img/w3_mc_light.f41a9922.png";